import { getTestData } from "./onBegin";
const TEST_LIST_SEPARATOR = " › ";
export const getReadonlyProjectNames = ({ projects }) => new Set(projects.flatMap(({ dependencies, teardown }) => teardown ? [...dependencies, teardown] : dependencies));
export const getOrchestrationTestData = (test, rootDir) => {
    const { title, describe, project, spec, historyId } = getTestData(test, rootDir);
    const { line, column } = test.location;
    return {
        id: historyId,
        title: [
            `[${project !== null && project !== void 0 ? project : ""}]`,
            `${spec}:${line}:${column}`,
            ...describe,
            title,
        ].join(TEST_LIST_SEPARATOR),
    };
};
//# sourceMappingURL=preprocess.js.map